import logo from './logo.svg';
import './App.css';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
    <Main/>
    <Footer/>
    </div>
  );
}

export default App;
